import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CurrencyPoundIcon from '@mui/icons-material/CurrencyPound';

export default function BasicTable() {
    return (
      <TableContainer
       sx={{
          // width: '300px', 
          // height:'500',
          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
          padding:'25px',
          bgcolor:'#f1f8e9',
          borderRadius: '20px',
          display: 'flex',
         }} 
        component={Paper}>
        <Table  size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
               
              <TableCell style={{fontWeight:'bold'}} >Total Collections&nbsp;</TableCell>
              <TableCell style={{fontSize: 15,textAlign:'center'}}><b> ￡17500</b> &nbsp;</TableCell>
             </TableRow>
          </TableHead>
          <TableBody>
               <TableRow>
                <TableCell >Cash</TableCell>
                <TableCell style={{fontSize: 10, textAlign:'center'}}><b>￡2250</b> </TableCell>
               </TableRow>
              <TableRow>
                <TableCell >Credit Card</TableCell>
                <TableCell style={{fontSize: 10, textAlign:'center'}}><b>￡10000</b> </TableCell>
               </TableRow> <TableRow>
                <TableCell >Bank Transfer</TableCell>
                <TableCell style={{fontSize: 10, textAlign:'center'}}><b>￡5250</b> </TableCell>
               </TableRow> <TableRow>
                <TableCell >Others</TableCell>
                <TableCell style={{fontSize: 10, textAlign:'center'}}><b>￡0</b> </TableCell>
               </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  }